import React, { useState } from 'react'
import Header from './Header';

const Calculater = () => {
  
   const[result,setResult]=useState("");

   const handleclick=(e)=>{
     setResult(result.concat(e.target.name))
   }
   const clear=()=>{
    setResult("")
   }
   const backspace=()=>{
    setResult(result.slice(0,-1))
   }
   const calculate=()=>{
    try{
    setResult(eval(result).toString())
    } catch(err){
      setResult("ERROR")
    }
   }
  return (<>
    <Header/>
    <div className='body3'>
    
      <div className="calculator">
    <div className="calculator__wrap">
        <div className="calculator__display" >
            <input type='text' value={result}  className='cal__input'/>
        </div>
        <div className="calculator__functions">
            <button onClick={clear} id="clear" className="btn--opaque">AC</button>
            <button onClick={backspace} id="backspace" className="btn--opaque"> ←</button>
            {/* <button onClick={handleclick} name="%" className="btn--opaque">%</button> */}
            <button onClick={handleclick} name="/" className="btn--opaque">/</button>
            <button onClick={handleclick} name="7">7</button>
            <button onClick={handleclick} name="8">8</button>
            <button onClick={handleclick} name="9">9</button>
            <button onClick={handleclick} name="*" className="btn--opaque">*</button>
            <button onClick={handleclick} name="4">4</button>
            <button onClick={handleclick} name="5">5</button>
            <button onClick={handleclick} name="6">6</button>
            <button onClick={handleclick} name="-" className="btn--opaque">-</button>
            <button onClick={handleclick} name="1">1</button>
            <button onClick={handleclick} name="2">2</button>
            <button onClick={handleclick} name="3">3</button>
            <button onClick={handleclick} name="+" className="btn--opaque">+</button>
            <button onClick={handleclick} name="0" className="btn--large">0</button>
            <button onClick={handleclick} name=".">.</button>
            <button onClick={calculate} id="result" className="btn--opaque">=</button>
        </div>
    </div>
</div>
    </div></>
  )
}

export default Calculater
